type EntitlementMetadataCommon = {
  readonly canApprove: boolean;
  readonly requiresApproval: boolean;
}

const entitlementIds = [
  'pos.banks.close.execute',
  'pos.banks.closeAmount.manage',
  'pos.banks.deposit.execute',
  'pos.banks.open.execute',
  'pos.banks.openAmount.manage',
  'pos.banks.read',
  'pos.banks.reopen.execute',
  'pos.banks.withdraw.execute',
  'pos.checks.86Items.create',
  'pos.checks.create',
  'pos.checks.discounts.create',
  'pos.checks.discounts.delete',
  'pos.checks.discounts.manage',
  'pos.checks.fees.manage',
  'pos.checks.items.void',
  'pos.checks.merge.execute',
  'pos.checks.payment.accept.execute',
  'pos.checks.payments.refund.execute',
  'pos.checks.prices.update',
  'pos.checks.read',
  'pos.checks.reopen.execute',
  'pos.checks.rewards.apply.execute',
  'pos.checks.split.execute',
  'pos.checks.transfer.execute',
  'pos.checks.update',
  'pos.checks.void',
  'pos.drawer.popAny.execute',
  'pos.drawer.popAssigned.execute',
  'pos.drawer.unassignFromSelf.execute',
  'pos.eod.result.read',
  'pos.eod.run.execute',
  'pos.money.payIn.execute',
  'pos.money.payIn.void',
  'pos.money.payOut.execute',
  'pos.money.payOut.void',
  'pos.money.tipOut.execute',
  'pos.timeClockOverride.execute',
  'pos.olo.updateConfig.update'
] as const;

type EntitlementId = typeof entitlementIds[number]

const entitlementWithMoreMetaDataIds = [
  'pos.checks.payment.accept.execute',
  'pos.checks.read',
  'pos.money.payIn.execute',
  'pos.money.tipOut.execute',
] as const;

type EntitlementMetaDataWithMoreId = typeof entitlementWithMoreMetaDataIds[number];

// Entitlement ids that have the common metadata("EntitlementMetadataCommon")
// - using "Exclude" to confirm we are pulling from the union("EntitlementId")
// - using "Exclude" w/ "EntitlementMetaDataWithMoreIds" to confirm we are pulling from the union("EntitlementId")
type EntitlementMetaDataCommonIds = Exclude<EntitlementId, EntitlementMetaDataWithMoreId>;

// FAIL: An attempt was made to lock down this record w/ keys of "EntitlementMetaDataWithMoreIds"
//  - anyone have any ideas
type EntitlementMetaDataWithMoreRecord = {
  ['pos.checks.read']: EntitlementMetadataCommon & { readonly canViewAll: boolean };
  ['pos.checks.payment.accept.execute']: EntitlementMetadataCommon & { readonly paymentMethodIds: number[]; };
  ['pos.money.payIn.execute']: EntitlementMetadataCommon & { readonly paymentMethodIds: number[]; };
  ['pos.money.tipOut.execute']: EntitlementMetadataCommon & { readonly tipOutSetting: 'None' | 'Any' | 'Assigned' };
  ['pos.checks.discounts.manage']: EntitlementMetadataCommon & { readonly standardDiscountIds: number[]; readonly allowAll: boolean; };
}

type EntitlementMetaDataCommonRecord = Record<EntitlementMetaDataCommonIds, EntitlementMetadataCommon>;

type EntitlementMetaDataRecord = EntitlementMetaDataCommonRecord & EntitlementMetaDataWithMoreRecord;

type EntitlementMetaDataFor<Key extends EntitlementId> = EntitlementMetaDataRecord[Key];

export { entitlementIds, entitlementWithMoreMetaDataIds };
export type { EntitlementId, EntitlementMetaDataCommonIds, EntitlementMetaDataFor, EntitlementMetaDataRecord, EntitlementMetaDataWithMoreId };
